App.directive('navContent', ['$rootScope', '$window', 'Config', '$mdDialog', function ($rootScope, $window, Config, $mdDialog) {
    return {
        restrict: 'AEC',
        scope: {
        	
        },
        templateUrl: Config.TEMPLATES_DIR + 'nav-content.html',
        link: function(scope) {
            
        }
    };
}]);